export const alertMessage = {
  zhtw: {
    title: '提示',
    content: '直播已經結束，現在切換重播，請稍後',
    buttonText: '確定'
  },
  en: {
    title: 'Alert',
    content: 'The live webcast ends and now switches to a replay, please wait.',
    buttonText: 'OK'
  }
};
